import React, { useEffect, useState } from 'react';
import { GetReportInput, GetReportOutput, Report } from 'aws-sdk/clients/d3aservice';
import { getReport } from 'src/api/d3a';
import { ReportDetail } from 'src/components/auditReports/reportDetail';
import { Button, Header, Modal, SpaceBetween, Spinner, TextContent } from '@amzn/awsui-components-react-v3';
import { DEFAULT_CONTENT_TYPE } from 'src/commons/constants';
import { Link } from 'src/components/common/Link';

export interface ReportDetailPageProps {
  setContentType: any;
  activeGroup: string;
  activeWorkspace?: any;
  setNotifications?: any;
}

export const ReportDetailPage = (props: ReportDetailPageProps) => {
  const [report, setReport] = useState<Report>(undefined);
  const [s3Urls, setS3Urls] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [downloadModalVisible, setDownloadModalVisible] = useState<boolean>(false);

  const reportId = () => {
    return props.match.params.id;
  };

  const handleRefresh = async () => {
    setLoading(true);
    props.setContentType(DEFAULT_CONTENT_TYPE);
    try {
      const getReportInput: GetReportInput = {
        reportId: reportId(),
      };

      const getReportOutput: GetReportOutput = await getReport(getReportInput);

      setReport(getReportOutput.report);
      setS3Urls(Object.values(getReportOutput.d3aProcessedS3UrlsMap));
    } catch (e) {}
    setLoading(false);
  };

  const handleDownload = () => {
    setDownloadModalVisible(true);
  };

  const handleDownloadAll = () => {
    s3Urls?.forEach((url, index) => {
      setTimeout(() => window.open(url, '_blank'), index * 1000);
    });
    setDownloadModalVisible(false);
  };

  useEffect(() => {
    handleRefresh();
  }, []);

  const fileNameForPresignedUrl = (url: string) => {
    const fileName = url.split('/').pop()?.split('?')[0];
    return fileName || 'Unknown';
  };

  if (loading) return <Spinner />;

  return (
    <>
      <Modal
        visible={downloadModalVisible}
        header={<Header variant={'h2'}>Download report</Header>}
        onDismiss={() => setDownloadModalVisible(false)}
        footer={
          <Header
            variant={'h2'}
            actions={
              <SpaceBetween size={'xs'} direction={'horizontal'}>
                <Button onClick={() => setDownloadModalVisible(false)}>Cancel</Button>
                <Button variant={'primary'} onClick={handleDownloadAll}>
                  Download all
                </Button>
              </SpaceBetween>
            }
          ></Header>
        }
      >
        <TextContent>
          <p>Select a link to download the associated file from S3, or select "Download all."</p>
          <ul>
            {s3Urls.map((url, index) => (
              <li key={index}>
                <Link href={url} external={true}>
                  {fileNameForPresignedUrl(url)}
                </Link>
              </li>
            ))}
          </ul>
        </TextContent>
      </Modal>
      <SpaceBetween size={'l'} direction={'vertical'}>
        <Header
          variant={'h1'}
          description={'Report ID: ' + report.reportId}
          actions={[
            <Button variant={'primary'} disabled={loading} onClick={handleDownload}>
              Download
            </Button>,
          ]}
        >
          {report.name}
        </Header>
        <ReportDetail
          setContentType={props.setContentType}
          activeGroup={props.activeGroup}
          report={report}
          s3Urls={s3Urls}
        />
      </SpaceBetween>
    </>
  );
};
